import { PDFDocument } from "pdf-lib";

export const convertBase64ToPdf = async (base64: string, fileName: string) => {
  // Decode the base64 string
  const decodedBytes = atob(base64);
  const uint8Array = new Uint8Array(decodedBytes.length);
  for (let i = 0; i < decodedBytes.length; i++) {
    uint8Array[i] = decodedBytes.charCodeAt(i);
  }

  // Load the PDF document
  const pdfDoc = await PDFDocument.load(uint8Array);

  // Create a Blob object from the PDF bytes
  const pdfBytes = await pdfDoc.save();
  const pdfBlob = new Blob([pdfBytes], { type: "application/pdf" });

  // Create a URL for the Blob object
  const url = URL.createObjectURL(pdfBlob);

  // Create a download link and trigger a click event
  const a = document.createElement("a");
  a.href = url;
  // const currentTime = new Date().getTime();
  a.download = fileName.endsWith(".pdf") ? fileName : `${fileName}.pdf`;
  document.body.appendChild(a);
  a.click();

  // Clean up
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);

  return true;
};

export const combineBase64ToPdf = async (
  base64Files: string[],
  outputFileName: string
) => {
  // Create a new PDFDocument to hold the combined pages
  const combinedPdf = await PDFDocument.create();

  for (const base64 of base64Files) {
    // Decode the base64 string into a Uint8Array
    const decodedBytes = atob(base64);
    const uint8Array = new Uint8Array(decodedBytes.length);
    for (let i = 0; i < decodedBytes.length; i++) {
      uint8Array[i] = decodedBytes.charCodeAt(i);
    }

    // Load the PDF document
    const pdfDoc = await PDFDocument.load(uint8Array);

    // Copy all pages from the current PDF into the combined PDF
    const pages = await combinedPdf.copyPages(pdfDoc, pdfDoc.getPageIndices());
    pages.forEach((page) => combinedPdf.addPage(page));
  }

  // Save the combined PDF as bytes
  const pdfBytes = await combinedPdf.save();

  // Create a Blob object from the combined PDF bytes
  const pdfBlob = new Blob([pdfBytes], { type: "application/pdf" });

  // Create a URL for the Blob object
  const url = URL.createObjectURL(pdfBlob);

  // Create a download link and trigger a click event
  const a = document.createElement("a");
  a.href = url;
  a.download = outputFileName.endsWith(".pdf")
    ? outputFileName
    : `${outputFileName}.pdf`;
  document.body.appendChild(a);
  a.click();

  // Clean up the URL object
  URL.revokeObjectURL(url);
};
